import React, { useEffect, useState } from "react";
import { observer } from "mobx-react";

import AIChatHistory from "./ai-chat-history";
import AIChatDialogue from "./ai-chat-dialogue";

import aiStore from "@app/state/store/ai";

import "./style/ai-chat.scoped.scss";

const AIChat = observer(({ source, readonly, enableDialogue = false }) => {
    const [editingMessage, setEditingMessage] = useState(null);

    useEffect(() => {
        aiStore.getChatHistory(source);

        return () => {
            aiStore.chatHistory = [];
        };
    }, [source._id]);

    const submitDialogue = async (message) => {
        if (!message) {
            return;
        }

        await aiStore.question(source, message);
        setEditingMessage(null);
    };

    const handleEditMessage = (content) => {
        setEditingMessage(content);
    };

    const handleCancel = () => {
        aiStore.cancelPrompt();
    };

    return (
        <div className="aiChatContainer">
            <AIChatHistory
                history={aiStore.chatHistory}
                onEditMessage={handleEditMessage}
                onCancel={handleCancel}
            />
            {!readonly && enableDialogue && (
                <AIChatDialogue
                    onSubmit={submitDialogue}
                    loading={aiStore.loading}
                    draftQuestion={aiStore.draftQuestion}
                    initialText={editingMessage}
                />
            )}
        </div>
    );
});

export default AIChat;
